import React, { useState } from 'react'
import {
  FadingBackground,
  FormInfoModal,
  InputBox,
  InputBoxContainer,
  InputBoxInsideContainer,
  NextIcon,
  SelectITSContainerOGTTH,
  SelectOTOGTTHContainer,
  SelectOptionContainerITSOGTTH,
  SelectOptionContainerOTOGTTH,
  SelectOptionImageITSOGTTH,
  SelectOptionSubtextITSOGTTH,
  SelectOptionTextContainerOGTTH,
  SelectOptionTextOTOGTTH,
  SelectOptionTitleITSOGTTH,
  SingleSelectOTOETContainer,
  SingleSelectOptionContainerOTOET,
  SelectOptionDot,
  SingleSelectOptionTextOTOET,
  UnderlineEffectTextButton,
  UnderlineEffectTextContainer,
  UnderlineEffectTextSpan,
  SelectITSContainerVertDes,
  SelectOptionContainerVertDes,
  SelectOptionImageVertDes,
  SelectOptionInternalContainerVertDes,
  SelectOptionTitleVertDes,
  SelectOptionSubtextVertDes,
  CustomTooltip,
  SelectedTick,
} from '../FormStyles'
import { ModalProvider } from 'styled-react-modal'
import DoneIcon from '@mui/icons-material/Done'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { useEffect } from 'react'

import green_filled_tick from 'src/assets/green_filled_tick.png'
import chinese_letter from 'src/assets/chinese_letter.png'
import filled_star from 'src/assets/filled-star.png'

export const TextInputComponent = (props) => {
  const { placeholder, data, setDataFunction, onSubmitFunction } = props

  const handleEnterClick = (event) => {
    if (event.key === 'Enter' && Boolean(data)) {
      onSubmitFunction()
    }
  }

  return (
    <InputBoxContainer>
      <InputBoxInsideContainer>
        <InputBox
          value={data}
          type="text"
          placeholder={placeholder}
          onChange={(e) =>
            setDataFunction(e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1))
          }
          onKeyDown={handleEnterClick}
          autoFocus
        />
        <NextIcon disabled={!Boolean(data)} onClick={onSubmitFunction}>
          <ChevronRightIcon sx={{ color: '#fff' }} />
        </NextIcon>
      </InputBoxInsideContainer>
    </InputBoxContainer>
  )
}

export const NumericInputComponent = (props) => {
  const { placeholder, data, setDataFunction, onSubmitFunction, minValue, maxValue, tooltip } =
    props

  const tooltipComp = (
    <Tooltip id="tooltip">
      <strong>{tooltip}</strong>
    </Tooltip>
  )

  const handleEnterClick = (event) => {
    if (event.key === 'Enter' && parseInt(data) >= minValue && parseInt(data) <= maxValue) {
      onSubmitFunction()
    }
  }

  return (
    <OverlayTrigger placement="bottom" overlay={tooltipComp} trigger="focus">
      <InputBoxContainer>
        <InputBoxInsideContainer>
          <InputBox
            value={data}
            type="number"
            placeholder={placeholder}
            onChange={(e) => setDataFunction(e.target.value)}
            onKeyDown={handleEnterClick}
          />
          <NextIcon
            disabled={!(parseInt(data) >= minValue && parseInt(data) <= maxValue)}
            onClick={onSubmitFunction}
          >
            <ChevronRightIcon sx={{ color: '#fff' }} />
          </NextIcon>
        </InputBoxInsideContainer>
      </InputBoxContainer>
    </OverlayTrigger>
  )
}

//////////// Selects : Title only, Options greater than 3 : prob here, why 3 for multi : mutli should not have limit

export const SingleSelectComponentOTOGTTH = (props) => {
  const { data, setDataFunction, fireSubmitOnSelection, onSubmitFunction, options } = props

  return (
    <SelectOTOGTTHContainer>
      {options?.map((item, index) => {
        return (
          <SelectOptionContainerOTOGTTH
            key={index}
            selected={item === data}
            onClick={() => {
              setDataFunction(item?.value)
              if (fireSubmitOnSelection) {
                onSubmitFunction(item?.value)
              }
            }}
          >
            <SelectOptionDot selected={item?.value === data} />
            <SelectOptionTextOTOGTTH>{item?.label}</SelectOptionTextOTOGTTH>
          </SelectOptionContainerOTOGTTH>
        )
      })}
    </SelectOTOGTTHContainer>
  )
}

export const MutliSelectVerticalComponentOTOGTTH = () => {
  const [selectedOptions, setSelectedOptions] = useState([])
  const options = ['Ford', 'BMW', 'Honda', 'Hyundai', 'M-Benz', 'GM', 'Suzuki']

  function handleOptionClick(item) {
    let temp = [...selectedOptions]
    let itemIndex = temp?.indexOf(item)
    if (itemIndex === -1) {
      temp?.push(item)
    } else {
      temp?.splice(itemIndex, 1)
    }
    setSelectedOptions(temp)
  }

  return (
    <SelectOTOGTTHContainer>
      {options?.map((item, index) => {
        return (
          <SelectOptionContainerOTOGTTH
            key={index}
            onClick={() => handleOptionClick(item)}
            selected={selectedOptions?.includes(item)}
          >
            <SelectOptionDot selected={selectedOptions?.includes(item)}>
              <DoneIcon sx={{ color: 'white' }} />
            </SelectOptionDot>
            <SelectOptionTextOTOGTTH>{item}</SelectOptionTextOTOGTTH>
          </SelectOptionContainerOTOGTTH>
        )
      })}
    </SelectOTOGTTHContainer>
  )
}

//////////// Select : Title Only, two options

export const SingleSelectComponentOTOET = () => {
  const [selectedOption, setSelectedOption] = useState()
  const options = ['Yes', 'No']

  return (
    <SingleSelectOTOETContainer>
      {options?.map((item, index) => {
        return (
          <SingleSelectOptionContainerOTOET
            selected={item === selectedOption}
            key={index}
            onClick={() => setSelectedOption(item)}
          >
            <SingleSelectOptionTextOTOET>{item}</SingleSelectOptionTextOTOET>
          </SingleSelectOptionContainerOTOET>
        )
      })}
    </SingleSelectOTOETContainer>
  )
}

///////////// Selects : Image Title Subtext

export const MultiSelectComponentITS = (props) => {
  const { data, setDataFunction, options } = props

  let temp = []
  options?.forEach((item) => {
    if (item?.preselected) {
      temp.push(item?.value)
    }
  })

  useEffect(() => {
    if (!Array.isArray(data)) {
      setDataFunction([...temp])
    }
  }, [])

  function handleOptionClick(item) {
    let temp = [...data]
    let itemIndex = temp?.indexOf(item)
    if (itemIndex === -1) {
      temp?.push(item)
    } else {
      temp?.splice(itemIndex, 1)
    }
    setDataFunction(temp)
  }

  return (
    <SelectITSContainerOGTTH>
      {options?.map((item, index) => {
        return (
          <SelectOptionContainerITSOGTTH
            key={index}
            onClick={() => handleOptionClick(item?.value)}
            selected={data?.includes(item?.value)}
          >
            {data?.includes(item?.value) && <SelectedTick src={green_filled_tick} />}
            <SelectOptionTextContainerOGTTH>
              <SelectOptionTitleITSOGTTH>{item?.title}</SelectOptionTitleITSOGTTH>
              <SelectOptionSubtextITSOGTTH>{item?.subtext}</SelectOptionSubtextITSOGTTH>
            </SelectOptionTextContainerOGTTH>
            {item?.image && <SelectOptionImageITSOGTTH src={item?.image} />}
          </SelectOptionContainerITSOGTTH>
        )
      })}
    </SelectITSContainerOGTTH>
  )
}

export const SingleSelectComponentITS = () => {
  const [selectedOption, setSelectedOption] = useState()
  const options = ['Kannada', 'Hindi', 'English', 'Sanskrit', 'English India']

  return (
    <SelectITSContainerOGTTH>
      {options?.map((item, index) => {
        return (
          <SelectOptionContainerITSOGTTH
            key={index}
            onClick={() => setSelectedOption(item)}
            selected={item === selectedOption}
          >
            <SelectOptionTextContainerOGTTH>
              <SelectOptionTitleITSOGTTH>हिंदी</SelectOptionTitleITSOGTTH>
              <SelectOptionSubtextITSOGTTH>{item}</SelectOptionSubtextITSOGTTH>
            </SelectOptionTextContainerOGTTH>
            <SelectOptionImageITSOGTTH src={chinese_letter} />
          </SelectOptionContainerITSOGTTH>
        )
      })}
    </SelectITSContainerOGTTH>
  )
}

///////////// Select : Image, Title, Subtext : only for 2 options

export const SingleSelectComponentITSOET = (props) => {
  const { data, setDataFunction, onSubmitFunction, options } = props

  return (
    <SelectITSContainerVertDes>
      {options?.map((item, index) => {
        return (
          <SelectOptionContainerVertDes
            key={index}
            selected={item?.value === data}
            onClick={() => {
              setDataFunction(item?.value)
              onSubmitFunction()
            }}
          >
            <SelectOptionImageVertDes src={item?.image} />
            <SelectOptionInternalContainerVertDes>
              <SelectOptionTitleVertDes>{item?.title}</SelectOptionTitleVertDes>
              <SelectOptionSubtextVertDes>{item?.subtext}</SelectOptionSubtextVertDes>
            </SelectOptionInternalContainerVertDes>
          </SelectOptionContainerVertDes>
        )
      })}
    </SelectITSContainerVertDes>
  )
}

export const MultiSelectComponentITSOET = () => {
  const options = ['Kannada', 'Hindi', 'English']

  return (
    <SelectITSContainerVertDes>
      {options?.map((item, index) => {
        return (
          <SelectOptionContainerVertDes key={index}>
            <SelectOptionImageVertDes src={filled_star} />
            <SelectOptionInternalContainerVertDes>
              <SelectOptionTitleVertDes>Test</SelectOptionTitleVertDes>
              <SelectOptionSubtextVertDes>test</SelectOptionSubtextVertDes>
            </SelectOptionInternalContainerVertDes>
          </SelectOptionContainerVertDes>
        )
      })}
    </SelectITSContainerVertDes>
  )
}

//////////////////

export const UnderlineEffectTextComponent = (props) => {
  const { openModalFunction } = props

  return (
    <UnderlineEffectTextContainer onClick={openModalFunction}>
      <UnderlineEffectTextSpan>
        <UnderlineEffectTextButton>{props?.text}</UnderlineEffectTextButton>
      </UnderlineEffectTextSpan>
    </UnderlineEffectTextContainer>
  )
}

/////////////

export const FormInfoModalComponent = (props) => {
  const { closeFunction } = props

  return (
    <ModalProvider backgroundComponent={FadingBackground}>
      <FormInfoModal isOpen={true}>
        <div onClick={() => closeFunction()}>close</div>
      </FormInfoModal>
    </ModalProvider>
  )
}

///////////////////

export const EmailPasswordComponent = (props) => {
  const { placeholderEmail, placeholderPassword, data, setDataFunction, onSubmitFunction } = props
  const [passwordVisible, setPasswordVisible] = useState(false)
  const [toolTipText, setToolTipText] = useState({
    emailToolTip: 'Enter a valid Email',
    passwordToolTip: 'Your Password should have at least 6 characters',
    emailValid: false,
    passwordValid: false,
  })

  const tooltipEmail = (
    <CustomTooltip id="tooltip" valid={toolTipText?.emailValid}>
      <strong>{toolTipText?.emailToolTip}</strong>
    </CustomTooltip>
  )
  const tooltipPassword = (
    <CustomTooltip id="tooltip" valid={toolTipText?.passwordValid}>
      <strong>{toolTipText?.passwordToolTip}</strong>
    </CustomTooltip>
  )

  const handleEnterClick = (event) => {
    if (event.key === 'Enter') {
      onSubmitFunction()
    }
  }

  return (
    <form>
      <OverlayTrigger placement="top" overlay={tooltipEmail} trigger="focus">
        <InputBoxContainer style={{ margin: '5px 0' }}>
          <InputBoxInsideContainer>
            <InputBox
              type="email"
              value={data?.email}
              placeholder={placeholderEmail}
              onChange={(e) => {
                setDataFunction({ ...data, email: e.target.value })
                if (e.target.value?.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
                  setToolTipText({ ...toolTipText, emailToolTip: 'Great !', emailValid: true })
                } else {
                  setToolTipText({
                    ...toolTipText,
                    emailToolTip: 'Enter a valid Email',
                    emailValid: false,
                  })
                }
              }}
            />
          </InputBoxInsideContainer>
        </InputBoxContainer>
      </OverlayTrigger>

      <OverlayTrigger placement="bottom" overlay={tooltipPassword} trigger="focus">
        <InputBoxContainer style={{ margin: '5px 0' }}>
          <InputBoxInsideContainer>
            <InputBox
              type={passwordVisible ? 'text' : 'password'}
              value={data?.password}
              placeholder={placeholderPassword}
              onKeyDown={handleEnterClick}
              onChange={(e) => {
                setDataFunction({ ...data, password: e.target.value })
                if (e.target.value.length >= 6) {
                  setToolTipText({
                    ...toolTipText,
                    passwordToolTip: 'Great !',
                    passwordValid: true,
                  })
                } else {
                  setToolTipText({
                    ...toolTipText,
                    passwordToolTip: 'Your Password should have at least 6 characters',
                    passwordValid: false,
                  })
                }
              }}
            />

            {passwordVisible ? (
              <VisibilityOffIcon
                sx={{ fontSize: 30, marginRight: '16px', cursor: 'pointer' }}
                onClick={() => setPasswordVisible(false)}
              />
            ) : (
              <VisibilityIcon
                sx={{ fontSize: 30, marginRight: '16px', cursor: 'pointer' }}
                onClick={() => setPasswordVisible(true)}
              />
            )}
          </InputBoxInsideContainer>
        </InputBoxContainer>
      </OverlayTrigger>
    </form>
  )
}
